import { Component, Input } from '@angular/core';
import { provideTranslocoScope } from '@ngneat/transloco';
import { LimitedTermDuration } from '@platform-frontend/checkout-drop-in';
import { PLATFORM_ENVIRONMENT } from '@platform-frontend/platform';
import { MARKETPLACE_TRANSLOCO_SCOPE } from '../../marketplace-transloco-scope';
import { LicenseKindType } from '../model/license-kind-type';
import { LicenseValidityContext, LicenseValidityDuration } from '../model/license-validity-context';
import { ProductCategory } from '../model/product-category';
import { isLimitedTermDuration } from './is-limited-term-duration';

@Component({
  selector: 'yat-license-validity',
  templateUrl: './license-validity.component.html',
  providers: [provideTranslocoScope(MARKETPLACE_TRANSLOCO_SCOPE)]
})
export class LicenseValidityComponent {
  @Input()
  licenseValidity?: LicenseValidityContext;

  @Input()
  productCategory: ProductCategory;

  @Input()
  licenseKindType: LicenseKindType;

  @Input()
  isLicenseValidityEditable: boolean;

  readonly isProduction = PLATFORM_ENVIRONMENT.isProduction;

  isLimitedTermDuration = isLimitedTermDuration;

  isEndDate(duration: LicenseValidityDuration | null): duration is Date | LimitedTermDuration {
    return duration !== null && duration !== 'UNLIMITED';
  }

  get hideLicenseValidity(): boolean {
    return (
      this.licenseKindType === 'SUBSCRIPTION' &&
      this.isLicenseValidityEditable === null &&
      this.licenseValidity?.duration === 'UNLIMITED' &&
      this.licenseValidity.asOfNow
    );
  }
}
